const theme = {
  colors: {
    '--logo-color': 'linear-gradient(135deg, var(--cheese), var(--primary))',
    '--main-hover-background-color': 'var(--grey6)',
    '--main-active-background-color': 'var(--grey2)',
    '--main-selected-background-color': 'var(--primary)',
    '--primary-text-color': 'var(--black)',
    background: {
      '--background': 'var(--dark-blue2)',
      '--variant': 'var(--dark-blue2)',
      '--surface': 'var(--grey-blue)',
    },
    content: {
      '--content-primary': 'var(--dark-blue2)',
      '--content-secondary': 'var(--grey-blue)',
      '--content-disabled': 'var(--light-slipper)',
      '--content-outline': 'var(--manatee)',
      '--content-link': 'var(--primary-color)',
    },
    semantic: {
      '--info': 'var(--vanadyl-blue)',
      '--success': 'var(--greedo-green)',
      '--warning': 'var(--clay-terrace)',
      '--error': 'var(--chi-gong)',
    },
  },
  fonts: {
    sizes: {
      '--font-size-xlarge': '42px',
      '--font-size-large': '22px',
      '--font-size-slarge': '18px',
      '--font-size-xmedium': '16px',
      '--font-size-medium': '14px',
      '--font-size-smedium': '12px',
      '--font-size-smal': '10px',
      '--header-font-size': 'var(--font-size-large)',
    },
    colors: {
      '--link-primary': 'var(--blue-150)',
      '--text-primary': 'var(--blue-150)',
    },
    fontFamilies: {
      '--main-font-family': 'var(--eptura-flexible)',
      '--code-font-family': 'var(--source-code-pro-font)',
    },
  },
  components: {
    headers: {
      '--h1-font-size': 'var(--font-size-large)',
    },
    gridTemplateColumns: {
      '--checkbox-1': 'var(--checkbox-1)',
      '--checkbox-2': 'var(--checkbox-2)',
      '--checkbox-3': 'var(--checkbox-3)',
      '--checkbox-4': 'var(--checkbox-4)',
      '--checkbox-5': 'var(--checkbox-5)',
      '--checkbox-6': 'var(--checkbox-6)',
      '--checkbox-7': 'var(--checkbox-7)',
      '--checkbox-8': 'var(--checkbox-8)',
      '--checkbox-9': 'var(--checkbox-9)',
      '--checkbox-10': 'var(--checkbox-10)',
    },
    tabs: {
      '--tab-color': 'var(--grey)',
      '--tab-color-hover': 'var(--black)',
      '--tab-color-active': 'var(--black)',
    },
    inputFields: {
      '--input-icon-color': 'var(--grey)',
      '--input-border-color': 'var(--light-border-color)',
      '--input-border-radius': '4px',
    },
    cards: {
      '--card-border-color': 'var(--grey2)',
      '--card-background-color': 'var(--white)',
      '--th-background-color': 'var(--white)',
    },
    buttons: {
      '--ghost-button-color': 'var(--primary-color)',
    },
    bigButton: {
      '--big-button-shadow': 'var(--blue-shadow)',
      '--big-button-radius': '8px',
      '--big-button-title-color': 'var(--dark-blue2)',
      '--big-button-subtitle-color': 'var(--shutter-blue)',
      '--big-button-title-size': 'var(--font-size-medium)',
      '--big-button-subtitle-size': 'var(--font-size-smal)',
    },
    popovers: {
      colors: {
        '--popovers-item-hover-color': 'var(--chef-hat)',
        '--popovers-item-selected-color': 'var(--light-violet)',
        '--popovers-item-selected-icon-color': 'var(--primary-color)',
      },
      font: {
        '--popovers-font': 'var(--eptura-flexible)',
        '--popovers-smal-subtitle-size': 'var(--font-size-smedium)',
        '--popovers-subtitle-size': 'var(--font-size-medium)',
        '--popovers-title-size': 'var(--font-size-xmedium)',
      },
    },
  },
}

export type ThemeT = typeof theme

export default theme
